import React from 'react';
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';
import { StarRatingComponent } from '../../../../common/StarRating';
import { IRatingVM } from '@lialo/core/lib/pages/tourDetail/models';
import { useTranslation } from 'react-i18next';
import ProfileAvatarLink from '../../../../common/ProfileAvatar/ProfileAvatarLink';
import ProfileAvatar from '../../../../common/ProfileAvatar/ProfileAvatar';
import { AuthorResponse } from './AuthorResponse';

const PREFIX = 'ReviewStarRatingListItem';

const classes = {
  userRating: `${PREFIX}-userRating`,
  flexColumn: `${PREFIX}-flexColumn`,
  container: `${PREFIX}-container`,
  commentDate: `${PREFIX}-commentDate`,
};

const StyledListItem = styled(ListItem)(({ theme }) => ({
  width: '100%',
  maxWidth: '100%',
  margin: theme.spacing(1, 0),
  backgroundColor: 'transparent',
  padding: 0,
  flexDirection: 'column',

  [`& .${classes.userRating}`]: {
    display: 'flex',
  },

  [`& .${classes.flexColumn}`]: {
    flexDirection: 'column',
  },

  [`& .${classes.container}`]: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'start',
  },

  [`& .${classes.commentDate}`]: {
    fontSize: '0.8rem',
    margin: theme.spacing(0, 1),
    color: theme.palette.grey[600],
  },
}));

type IProps = IRatingVM;

export default function ReviewStarRatingListItem(props: IProps) {
  const { t } = useTranslation();

  return (
    <StyledListItem alignItems="flex-start">
      <div className={classes.userRating}>
        <ListItemAvatar>
          {props.user?.anonymous ?? true ? (
            <ProfileAvatar size={48} user={props.user} />
          ) : (
            <ProfileAvatarLink hideBadge={true} size={48} user={props.user} />
          )}
        </ListItemAvatar>

        <ListItemText
          primary={props.name ?? t('tour_detail.reviews.guest')}
          secondary={
            <>
              <span className={classes.container}>
                <StarRatingComponent value={props.rating} readOnly={true} fractions={1} />
                <Typography component={'span'} className={classes.commentDate} variant={'body2'}>
                  {props.userCommentDate}
                </Typography>
              </span>
              <span className={classes.flexColumn}>
                <Typography component={'span'} variant={'body1'}>
                  {props.userComment}
                </Typography>
              </span>
            </>
          }
        />
      </div>
      {props.authorResponse && <AuthorResponse response={props.authorResponse} />}
    </StyledListItem>
  );
}
